export const APPLIANCE_TYPES = [
  { key: "brackets_metalicos", label: "Brackets metálicos" },
  { key: "brackets_esteticos", label: "Brackets estéticos (cerámica/zafiro)" },
  { key: "autoligado", label: "Brackets de autoligado" },
  { key: "alineadores", label: "Alineadores transparentes" },
  { key: "removible", label: "Aparatología removible / ortopedia" },
];
export const APPLIANCE_LABEL = Object.fromEntries(APPLIANCE_TYPES.map((a) => [a.key, a.label]));

export const ORTHO_PHASES = [
  { key: "alineacion", label: "Alineación" },
  { key: "nivelacion", label: "Nivelación" },
  { key: "cierre_espacios", label: "Cierre de espacios" },
  { key: "finalizacion", label: "Finalización / detallado" },
  { key: "retencion", label: "Retención" },
];
export const PHASE_LABEL = Object.fromEntries(ORTHO_PHASES.map((p) => [p.key, p.label]));

export const ARCH_OPTIONS = [
  "0.012 NiTi", "0.014 NiTi", "0.016 NiTi", "0.018 NiTi", "0.016x0.022 NiTi", "0.017x0.025 NiTi", "0.019x0.025 NiTi",
  "0.016 Acero", "0.018 Acero", "0.016x0.022 Acero", "0.017x0.025 Acero", "0.019x0.025 Acero", "0.021x0.025 Acero",
];

export const CASE_STATUS = { activo: "Activo", finalizado: "Finalizado", retirado: "Retirado" };

export const INST_STATUS = {
  pendiente: { label: "Pendiente", cls: "bg-muted text-muted-foreground border-border" },
  vencido: { label: "Vencida", cls: "bg-destructive/10 text-destructive border-destructive/30" },
  pagado: { label: "Pagada", cls: "bg-primary/10 text-primary border-primary/30" },
};

export const fmtDate = (s) => {
  if (!s) return "—";
  const [y, m, d] = s.slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" });
};

export const monthsBetween = (startIso) => {
  if (!startIso) return 0;
  const [y, m, d] = startIso.slice(0, 10).split("-").map(Number);
  const s = new Date(y, m - 1, d), n = new Date();
  return Math.max(0, (n.getFullYear() - s.getFullYear()) * 12 + (n.getMonth() - s.getMonth()) - (n.getDate() < s.getDate() ? 1 : 0));
};

export const todayIso = () => new Date().toISOString().slice(0, 10);
